module.exports = __webpack_public_path__ + "static/lageplan_einkaufen-741fae1ae6003f02c637253a594fe876.png";